/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { WorkflowTemplatesControllerRemoveMutationResponse, WorkflowTemplatesControllerRemovePathParams, WorkflowTemplatesControllerRemove401, WorkflowTemplatesControllerRemove403, WorkflowTemplatesControllerRemove404 } from "../../models/workflowsController/WorkflowTemplatesControllerRemove";

function getWorkflowTemplatesControllerRemoveUrl(id: WorkflowTemplatesControllerRemovePathParams["id"]) {
  const res = { method: 'DELETE', url: `/api/v1/workflow-templates/${id}` as const }  
  return res
}

/**
 * @summary Soft-delete a workflow template
 * {@link /api/v1/workflow-templates/:id}
 */
export async function workflowTemplatesControllerRemove(id: WorkflowTemplatesControllerRemovePathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<WorkflowTemplatesControllerRemoveMutationResponse, ResponseErrorConfig<WorkflowTemplatesControllerRemove401 | WorkflowTemplatesControllerRemove403 | WorkflowTemplatesControllerRemove404>, unknown>({ method : "DELETE", url : getWorkflowTemplatesControllerRemoveUrl(id).url.toString(), ... requestConfig })  
  return res.data
}